import { memo } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { useThemeMode } from '@/app/hooks/useThemeMode';

interface DarkModeToggleProps {
  className?: string;
}

const DarkModeToggle = (props: DarkModeToggleProps) => {
  const { className } = props;
  const { isDark, toggleThemeMode } = useThemeMode();

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'} placement='bottom'>
      <IconButton
        onClick={toggleThemeMode}
        className={clsx('w-40 h-40', className)}
        size='large'
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? (
          <FuseSvgIcon>heroicons-outline:sun</FuseSvgIcon>
        ) : (
          <FuseSvgIcon>heroicons-outline:moon</FuseSvgIcon>
        )}
      </IconButton>
    </Tooltip>
  );
};

export default memo(DarkModeToggle);
